import * as React from "react"
import type { SVGProps } from "react"
const SvgAlarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 19.71a1 1 0 0 1-.71-.28A1 1 0 0 1 4 18.7q0-.43.29-.7a1 1 0 0 1 .71-.3h1v-7q0-2.06 1.25-3.68A5.8 5.8 0 0 1 10.5 4.9v-.7q0-.62.44-1.06A1.5 1.5 0 0 1 12 2.71q.63 0 1.06.44.45.45.44 1.06v.7a5.8 5.8 0 0 1 3.25 2.12A6 6 0 0 1 18 10.7v7h1q.42 0 .71.3.3.28.29.7 0 .43-.29.72a1 1 0 0 1-.71.28zm7 3q-.83 0-1.41-.58A2 2 0 0 1 10 20.7h4q0 .82-.59 1.42a2 2 0 0 1-1.41.58m-4-5h8v-7q0-1.65-1.17-2.82Q13.65 6.7 12 6.7c-1.65 0-2.04.4-2.82 1.18A4 4 0 0 0 8 10.7z" />
  </svg>
)
export default SvgAlarm
